import React from 'react';

var SvgSettingsMajor = function SvgSettingsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.027 0a1 1 0 0 0-.99.859l-.37 2.598a6.993 6.993 0 0 0-1.925 1.113l-2.437-.98a1 1 0 0 0-1.239.428l-1.132 1.963a1 1 0 0 0 .248 1.287l2.066 1.621a7.06 7.06 0 0 0 0 2.222l-2.066 1.621a1 1 0 0 0-.248 1.287l1.132 1.962a1 1 0 0 0 1.239.428l2.438-.979a6.995 6.995 0 0 0 1.923 1.113l.372 2.598a1 1 0 0 0 .99.859h2.265a1 1 0 0 0 .99-.859l.371-2.598a6.995 6.995 0 0 0 1.924-1.112l2.438.978a1 1 0 0 0 1.238-.428l1.133-1.962a1 1 0 0 0-.249-1.287l-2.065-1.621a7.063 7.063 0 0 0 0-2.222l2.065-1.621a1 1 0 0 0 .249-1.287l-1.133-1.962a1 1 0 0 0-1.239-.428l-2.437.979a6.994 6.994 0 0 0-1.924-1.113l-.371-2.597a1 1 0 0 0-.99-.859h-2.266zm1.133 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
  }));
};

export { SvgSettingsMajor as S };
